import { session, sessionReady } from '@/shared/services/session/instance'

import type { AxiosInstance } from 'axios'

export function attachAuthInterceptor(client: AxiosInstance): void {
  client.interceptors.request.use(async config => {
    try {
      // PORTÃO: nenhuma requisição autenticada sai antes da restauração inicial
      // resolver. Sem isto, a montagem de uma tela dispara N requisições sem
      // token, todas levam 401 e todas competem por renovação.
      //
      // Substitui o `getCachedSession`, que era um wrapper single-flight sobre
      // `getSession()` criado para o mesmo problema — mas do lado errado: ele
      // cuidava de não multiplicar a chamada, e não de esperar o boot. Agora o
      // token é leitura síncrona de memória e não há chamada a deduplicar.
      await sessionReady()

      const token = session.tokenStore.get()

      if (token) config.headers.Authorization = `Bearer ${token}`
    } catch {}

    return config
  })
}
